import { render, staticRenderFns } from "./CorporateCustomer.vue?vue&type=template&id=a309c90c"
import script from "./CorporateCustomer.vue?vue&type=script&lang=js"
export * from "./CorporateCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports